__turbopack_context__.v({
  "Wrapper": "Interactive-module-scss-module__Z4X3Ua__Wrapper",
  "Wrapper___saturation": "Interactive-module-scss-module__Z4X3Ua__Wrapper___saturation",
});
